import { combineEpics, createEpicMiddleware, Epic, StateObservable } from 'redux-observable'
import { BehaviorSubject, Observable } from 'rxjs'
import { mergeMap } from 'rxjs/operators'

import { authEpics } from './auth'
import { dashboardEpics } from './dashboard'
import { notificationsEpics } from './notifications'
import { soundEpics } from './sound'

export const epic$ = new BehaviorSubject(combineEpics(
  ...Object.values(authEpics) as Epic[],
  ...Object.values(dashboardEpics) as Epic[],
  ...Object.values(notificationsEpics) as Epic[],
  ...Object.values(soundEpics) as Epic[]
))

export const rootEpic = (
  action$: Observable<any>,
  state$: StateObservable<any>,
  deps: {}
): Observable<unknown> => epic$.pipe(
  mergeMap(epic => epic(action$, state$, deps))
)

export const epicMiddleware = createEpicMiddleware({
  dependencies: {
  },
})

/**
 * Inject epics to global store
 *
 * @param epics
 */
export const injectEpics = (epics: Array<Epic>) => {
  epics.forEach(epic => epic$.next(epic))
}
